"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.parseOneTrustCookie = parseOneTrustCookie;
var _utils = _interopRequireDefault(require("../../utils"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var ONETRUST_COOKIE = 'OptanonConsent';
var ONETRUST_FUNCTIONAL_COOKIE_GROUP = 'C0003';

/**
 * Checks for and parses the information stored in the OneTrust cookie
 *
 * @returns Whether the OneTrust cookie exists and the information stored within it
 */
function parseOneTrustCookie() {
  var cookieValue = (0, _utils.default)(ONETRUST_COOKIE, '');
  var retVal = {
    hasOneTrustCookie: !!cookieValue,
    keyValues: {},
    groups: {}
  };
  if (retVal.hasOneTrustCookie) {
    cookieValue.split('&').forEach(function (token) {
      var keyVal = token.split('=').map(function (piece) {
        return decodeURIComponent(piece);
      });
      var key = keyVal.shift();
      var value = keyVal.length ? keyVal.shift() : true;
      if (key) {
        retVal.keyValues[key] = value;
      }
    });

    // fix up groups to be cleaner
    if (typeof retVal.keyValues.groups === 'string') {
      retVal.keyValues.groups.split(',').forEach(function (group) {
        var tokens = group.split(':');
        retVal.groups[tokens[0]] = tokens[1] === '1';
      });
    }
  }
  return retVal;
}

/**
 * Checks for cookie consent via the OneTrust banner
 *
 * @returns Whether functional cookies are blocked by OneTrust
 */
var blockedByOneTrust = function blockedByOneTrust() {
  var _parseOneTrustCookie = parseOneTrustCookie(),
    hasOneTrustCookie = _parseOneTrustCookie.hasOneTrustCookie,
    oneTrustGroups = _parseOneTrustCookie.groups;
  return !(hasOneTrustCookie && oneTrustGroups[ONETRUST_FUNCTIONAL_COOKIE_GROUP] === true);
};

/**
 * Checks for cookie consent via the Fides banner
 *
 * @returns Whether functional cookies are blocked by Ethyca Fides
 */
var blockedByFides = function blockedByFides() {
  var _Fides;
  return !((_Fides = window.Fides) !== null && _Fides !== void 0 && (_Fides = _Fides.consent) !== null && _Fides !== void 0 && _Fides.functional);
};

/**
 * Returns whether or not functional cookies have been consented to via the cookie
 * consent banner, allowing for multiple cookie consent providers.
 *
 * @param overrideCookieConsent Allow cookie consent to be overridden by the consuming application.
 *                              This is largely for internal tools.
 * @returns
 */
var blockedByCookieConsent = function blockedByCookieConsent() {
  var overrideCookieConsent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  if (overrideCookieConsent) {
    return false;
  }

  // we should only have one cookie consent provider at any given time, however we're
  // aiming to seamlessly bridge the gap. since both "blockedBy" methods fall back to blocked
  // in the event that their respective provider hasn't yet been initialized, we'll get a
  // double `true` (blocked) when:
  // - neither provider has initialized their code yet; we need to wait
  // - one provider hasn't initialized because they don't exist, and the other is stating
  //   that functional cookies are explicitly allowed
  // in the event that either of these methods returns false, that means the provider has
  // done its thing and that functional cookies are allowed per that provider's rules.
  //
  // ...this has been eleven lines of comment to over explain the `&&` operator below...
  return blockedByOneTrust() && blockedByFides();
};
var _default = exports.default = blockedByCookieConsent;
//# sourceMappingURL=consent.js.map